import { Component, OnInit } from '@angular/core';
import { CommonServiceService } from 'src/app/shared/common-service/common-service.service';
import { KeycloakService } from '../../shared/auth-service/auth.service';

@Component({
  selector: 'app-dashboard-container',
  templateUrl: './dashboard-container.component.html',
})
export class DashboardContainerComponent implements OnInit {
  getUserDetails:any;
  getLocalUser;

  constructor(private keycloakAngular: KeycloakService, private commonService:CommonServiceService,) { }

  ngOnInit(): void {
    this.getLoggedinUser();
    this.getLocalUser = localStorage.userDetails? JSON.parse(localStorage.userDetails) :'';
  }


  async getLoggedinUser() {
    await this.keycloakAngular.loadProfile().then(user => {
       this.getUserDetails = user;
    })
  }

  logout(): void{
    KeycloakService.logout();
    localStorage.removeItem('userDetails');
    localStorage.removeItem('dialCode');
    localStorage.removeItem('organizationName');
    localStorage.removeItem('organizationID');
    localStorage.removeItem('overlay');
    localStorage.removeItem('selectedValue');
    
  }

  ngDoCheck(){
    if(!this.getLocalUser.defaultLogoUrl){
      if(localStorage.userDetails){
        let getLocaldata = JSON.parse(localStorage.userDetails);
        if(!getLocaldata.defaultLogoUrl) return;
        this.getLocalUser = {
          defaultLogoUrl:getLocaldata.defaultLogoUrl
        }
      }
    }
  }

}
